// BoingAnimation.js
var BoingAnimation = pc.createScript('boingAnimation');

BoingAnimation.attributes.add('scaleInValue',{type: 'number'});
BoingAnimation.attributes.add('scaleOutValue',{type: 'number'});

var boingAnim;
BoingAnimation.prototype.initialize = function() {

    BoingAnimation.instance = this;
    this.stage1();
    this.entity.on("destroy", this.OnDestroy,this);
};

BoingAnimation.prototype.stage1 = function () {
    boingAnim = this.entity.tween(this.entity.getLocalScale()).to({ x: this.scaleOutValue, y: this.scaleOutValue, z: this.scaleOutValue }, 0.2, pc.Linear).on('complete', function () { BoingAnimation.instance.stage2(); }).delay(1);
    boingAnim.start();
};

BoingAnimation.prototype.stage2 = function() {
    boingAnim = this.entity
    .tween(this.entity.getLocalScale())
    .to(new pc.Vec3(this.scaleInValue, this.scaleInValue, this.scaleInValue), 0.2, pc.Linear)
    .on('complete', function(){BoingAnimation.instance.stage1();})
    .start();
};

BoingAnimation.prototype.OnDestroy = function(){
    boingAnim.stop();
    this.entity.off("destroy", this.OnDestroy,this);
};


